/** @format */

import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import cn from "classnames";
import UploadCloudIcon from "../../shared/icons/UploadCloudIcon";
import { useAmplitude } from "../../../hooks/useAmplitude";
import Loading from "../../shared/Loading/Loading";
import DeleteNewIcon from "../../shared/icons/DeleteNewIcon";
import EditIconNew from "../../shared/icons/EditIconNew";
import DocumentNewIcon from "../../shared/icons/DocumentNewIcon";
import { t } from "i18next"

const formatDocumentType = (contentType) => {
  const mimeMap = {
    "application/pdf": "pdf",
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/webp": "webp",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
  };

  return mimeMap[contentType] || contentType?.split("/")[1] || "unknown";
};

const CustomUploadFile = ({ user, files, onUploadFiles }) => {
  const { amplitude } = useAmplitude();
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [dragOver, setDragOver] = useState(false);

  const handleFileChangeSecond = (event) => {
    const newFiles = Array.from(event.target.files);
    onUploadFiles([...files, ...newFiles]);
  };

  const handleDropSecond = (event) => {
    event.preventDefault();
    setDragOver(false);
    const newFiles = Array.from(event.dataTransfer.files);
    onUploadFiles([...files, ...newFiles]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleUpload = () => {
    // Логика для редактирования файла
    console.log("Редактирование файла");
  };

  const handleDeleteDocument = (index) => {
    setIsLoadingDelete(true);
    const updatedFiles = files.filter((_, i) => i !== index);
    onUploadFiles(updatedFiles);
    setIsLoadingDelete(false);
  };

  return (
    <>
      {files.length === 0 ? (
        <div
          className={cn(style.drop_box)}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDropSecond}
        >
          <div className={style.drop_icon}>
            <UploadCloudIcon style={{ color: "#FA1861" }} />
          </div>
          <div className={style.drop_content}>
            <span className={style.drop_title}>
              {t('additionalDocuments')}
            </span>
            <div className={cn(style.drop_textUpload)}>
              <label className={style.drop_uploadFile}>
                <input
                  type="file"
                  onChange={handleFileChangeSecond}
                  style={{ display: "none" }}
                />
                <span>{t('uploadFiles')}</span>
              </label>
              <span className={style.drop_boxText}>
                {t('dragDocsHere')}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={cn(style.fails)}>
            {files.map((file, index) => (
              <div key={index} className={style.fileItem}>
                <div className={style.fileItem_icon}>
                  <DocumentNewIcon />
                </div>
                <div className={style.fileItem_content}>
                  <div className={style.fileItem_name}>{file.name}</div>
                  <div className={style.fileItem_size}>
                    {(file.size / 1024).toFixed(2)} kb・{t('uploaded')}
                  </div>
                </div>
                <EditIconNew
                  width={24}
                  height={24}
                  onClick={handleUpload}
                  style={{ cursor: "pointer" }}
                />
                {isLoadingDelete ? (
                  <Loading
                    inBlock
                    marginBottom={0}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <DeleteNewIcon
                    onClick={() => handleDeleteDocument(index)}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default CustomUploadFile;
